const rulesContent = `
  <h1>REGLAS – PRODE MUNDIAL</h1>
  <h2>PÁGINA|12</h2>

  <p>Cómo funciona el juego y privacidad</p>

  <h3>1. Organizador</h3>

  <p>
    El presente juego denominado <strong>“Prode Mundial Página|12”</strong>
    (en adelante, el “Juego”) es organizado por Página|12
    (en adelante, el “Organizador”).
  </p>

  <h3>2. Aceptación de las Bases</h3>

  <p>
    La participación en el Juego implica el conocimiento y la aceptación total
    de las presentes Bases y Condiciones.
  </p>

  <h3>3. Participantes</h3>

  <p>
    Podrán participar todas las personas humanas mayores de 18 años
    <strong><u> residentes en la República Argentina</u></strong>,
    con registro válido en el sitio web del Organizador.
  </p>

  <p>El Juego contempla dos tipos de usuarios:</p>

  <ul>
    <li><strong>Usuarios suscriptores (Soci@s)</strong></li>
    <li><strong>Usuarios no suscriptores</strong></li>
  </ul>

  <p>
    Las funcionalidades disponibles podrán variar según la condición del usuario.
  </p>

  <h3>4. Mecánica del Juego</h3>

  <p>
    El Juego consiste en pronosticar resultados de los partidos
    correspondientes al Mundial de Fútbol 2026,
    desde la fase de grupos hasta la final.
  </p>

  <p>
    Los participantes podrán cargar sus predicciones antes del inicio del torneo
    (“Mi Mundial Ideal”) y podrán sumarse en cualquier momento,
    sin acumular puntos de los partidos que ya se jugaron.
  </p>

  <h3>5. Plazos para pronósticos y modificaciones</h3>

  <ul>
    <li>
      Una vez iniciado el primer partido del torneo los pronósticos quedarán
      bloqueados y no podrán ser modificados,
      excepto para los suscriptores del programa Soci@s.
    </li>
  </ul>

  <p><strong>Condiciones según tipo de usuario</strong></p>

  <ul>
    <li>
      <strong>Suscriptores Soci@s:</strong>
      <u>
        contarán con 3 (tres) comodines que, a partir de 16avos. de final,
        les permitirán actualizar el cuadro.
      </u>

      Si los equipos clasificados en el torneo real no coinciden
      con los pronosticados originalmente por el usuario,
      este podrá activar un comodín para
      <strong><u>actualizar la fase eliminatoria vigente
      (siempre antes de su inicio)</u></strong>
      y cargar nuevos pronósticos basados en los cruces reales.

      La activación de comodines no suma ni resta puntos.
      No se podrán usar comodines para la final.
    </li>

    <li>
      <strong>No suscriptores:</strong>
      podrán cargar sus pronósticos una única vez,
      sin posibilidad de modificación posterior.

      Si el usuario decide convertirse en suscriptor,
      cuenta con tres comodines y tendrá los mismos beneficios
      que un suscriptor, posibilidad que solo estará disponible
      hasta la fase de semifinales.
    </li>
  </ul>

  <h3>6. Sistema de puntuación</h3>

  <h4>6.1 Fase de grupos y partidos en general</h4>

  <p>Los y las participantes podrán obtener puntos por:</p>

  <ul>
    <li>Resultado correcto (ganador o empate): 3 puntos</li>
    <li>Resultado exacto (marcador preciso): 5 puntos</li>
  </ul>

  <p>
    El puntaje por resultado exacto reemplaza al de resultado correcto,
    no siendo acumulables.
  </p>

  <h4>6.2 Fases eliminatorias</h4>

  <p>
    Para los partidos correspondientes a dieciseisavos,
    octavos de final, cuartos de final, semifinales y final:
  </p>

  <ul>
    <li>Equipo clasificado correcto: 5 puntos</li>
    <li>Resultado exacto: 8 puntos</li>
  </ul>

  <p>
    En caso de partidos definidos por tiempo suplementario o penales,
    se considerará como resultado válido el correspondiente
    a los 90 minutos reglamentarios,
    salvo indicación expresa en contrario por parte del Organizador.
  </p>

  <p>
    <u>
      En caso de optar por el empate,
      el jugador deberá elegir qué equipo será el que clasifique
      a la próxima ronda.
    </u>
  </p>

  <p>
    Si un partido se cancela y no se disputa en ningún momento,
    ningún jugador sumará o perderá puntos por su pronóstico.
  </p>

  <h3>7. Mi Mundial Ideal</h3>

  <p>
    Los y las participantes que mantengan sus pronósticos originales,
    cargados antes del inicio del torneo,
    acierten a todos los resultados y completen el Mundial
    sin haber utilizado ningún comodín ni realizado modificaciones,
    obtendrán al final del torneo un bonus de 10 puntos.
  </p>

  <h3>8. Ranking y criterios de desempate</h3>

  <p>
    Los y las participantes serán ordenados/as en rankings
    según el puntaje acumulado.
  </p>

  <p>
    En caso de empate en puntos se aplicarán los siguientes criterios
    de desempate, por orden de importancia:
  </p>

  <ol>
    <li>Mayor cantidad de resultados exactos acertados</li>
    <li>Mayor cantidad de resultados correctos acertados</li>
    <li>Menor cantidad de comodines utilizados</li>
    <li>Mayor antigüedad en el programa de suscripciones Soci@s de Página|12</li>
    <li>Fecha y hora de registro en el Juego (prioridad para el más antiguo)</li>
  </ol>

  <p>
    Ganarán los/las tres jugadores/as con mejor puntaje.
  </p>

  <h3>9. Actualización de resultados</h3>

  <p>
    Los puntajes serán actualizados automáticamente una vez finalizados
    los partidos, pudiendo existir demoras razonables en la acreditación.
  </p>

  <p>
    El Organizador se reserva el derecho de revisar y ajustar puntajes
    ante eventuales errores o inconsistencias.
  </p>

  <h3>10. Conductas prohibidas</h3>

  <p>Queda prohibido:</p>

  <ul>
    <li>Crear múltiples cuentas con el fin de obtener ventajas indebidas</li>
    <li>Manipular o intentar alterar el funcionamiento del sistema</li>
    <li>Utilizar el Juego con fines fraudulentos o contrarios a la buena fe</li>
  </ul>

  <p>
    El incumplimiento podrá derivar en la anulación de la participación
    sin derecho a reclamo.
  </p>

  <h3>11. Modificaciones</h3>

  <p>
    El Organizador podrá modificar total o parcialmente
    las presentes Bases y Condiciones por razones operativas,
    técnicas o comerciales, notificando dichas modificaciones
    a través de los canales habituales del sitio.
  </p>

  <h3>12. Responsabilidad</h3>

  <p>
    El Organizador no será responsable por fallas técnicas,
    errores de conexión, problemas de acceso a internet
    o cualquier otro inconveniente que impida la correcta participación
    en el Juego.
  </p>

  <h3>13. Aceptación final</h3>

  <p>
    La participación en el Juego implica la aceptación plena
    de estas Bases y Condiciones,
    así como de las decisiones que adopte el Organizador
    sobre cualquier cuestión no prevista en las mismas.
  </p>

  <h3>14. Privacidad de datos</h3>

  <p>
    Los datos personales facilitados por los participantes
    serán tratados de conformidad con la Ley 25.326
    de Protección de Datos Personales de la República Argentina.
  </p>
`;

export default rulesContent;